import { Component } from '@angular/core';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ImprestService } from '../services/imprest.service';
import { ILoggedInUser } from '../../interfaces/common/loggedInUser';
import { SearchParameters } from '../../shared/models/searchParameters.model';
import { SearchImprestChangesModel } from '../models/search-imprest-changes.model';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PagedResult } from '../../shared/models/pagedResult.model';
import { ImprestVendorsChangesModel } from '../models/imprest-vendor-changes.model';

@Component({
  selector: 'app-imprest-vendors-changes',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatProgressSpinnerModule, MatPaginatorModule, MatTableModule],
  templateUrl: './imprest-vendors-changes.component.html',
  styleUrl: './imprest-vendors-changes.component.scss'
})
export class ImprestVendorsChangesComponent {
  searchForm: FormGroup;
  user: ILoggedInUser;
  isAdmin: boolean = false;
  searchRequestParams: SearchParameters<SearchImprestChangesModel>;
  isLoading: boolean = false;
  pagedData: PagedResult<ImprestVendorsChangesModel[]>;
  totalCount: number;
  pageSize: number = 10;
  pageIndex: number;
  dataSource: MatTableDataSource<ImprestVendorsChangesModel>;
  searchDone: boolean = false;
  displayedColumns: string[] = ['number', 'time', 'action', 'vendor', 'payee', 'actionBy'];

 constructor(
    private userService: LoggedInUserService,
    private fb: FormBuilder,
    private imprestService: ImprestService) {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      vendor: new FormControl(''),          
      payee: new FormControl(''),
      fromDate: new FormControl(''),
      toDate: new FormControl('')
    });

    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user != null && this.user.adminRight){
        this.isAdmin = this.user.adminRight;        
      }      
    });
  }

  submitForm(): void {
    this.searchRequestParams = {
      query: {
        vendor: this.searchForm.get('vendor').value || null,
        payee: this.searchForm.get('payee').value || null,
        fromDate: this.searchForm.get('fromDate').value || null,
        toDate: this.searchForm.get('toDate').value || null
      },
      pageIndex: 0,
      pageSize: 10,
      userEmail: this.user.userEmail      
    };
    
    this.search();
  }

  search() {
    if(this.isAdmin){
      this.isLoading = true;
      this.imprestService.searchImprestVendorsChanges(this.searchRequestParams)
        .subscribe(data => {
          this.pagedData = data;
          this.pageSize = this.pagedData.pageSize;
          this.totalCount = this.pagedData.totalCount;      
          this.dataSource = new MatTableDataSource<ImprestVendorsChangesModel>(this.pagedData.items);          
          this.isLoading = false;
          this.searchDone = true;
      });
    }
    else{
      this.dataSource = new MatTableDataSource<ImprestVendorsChangesModel>([]);
    }
  }
  
  public pageChangeEvent(event?: PageEvent){
      this.searchRequestParams.pageIndex = event.pageIndex;
      this.searchRequestParams.pageSize = event.pageSize;
      this.search();
    }  
}
